<template>
  <div class="login-container">
    <h2>用户登录</h2>
    <el-form ref="loginForm" :model="loginForm" :rules="rules" label-width="80px">
      <el-form-item label="用户名" prop="username">
        <el-input v-model="loginForm.username" placeholder="请输入用户名"></el-input>
      </el-form-item>
      <el-form-item label="密码" prop="password">
        <el-input type="password" v-model="loginForm.password" placeholder="请输入密码"></el-input>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="submitForm" :loading="loading">登录</el-button>
      </el-form-item>
      <div v-if="error" class="error-message">{{ error }}</div>
    </el-form>
  </div>
</template>

<script>
// 使用带拦截器的请求工具
import request from '@/utils/request';

export default {
  name: 'LoginView',
  data: function() {
    return {
      loginForm: {
        username: '',
        password: ''
      },
      rules: {
        username: [{ required: true, message: '请输入用户名', trigger: 'blur' }],
        password: [{ required: true, message: '请输入密码', trigger: 'blur' }]
      },
      loading: false,
      error: ''
    };
  },
  created: function() {
    // 如果已登录，跳转到首页
    if (localStorage.getItem('token')) {
      this.$router.push('/');
    }
  },
  methods: {
    submitForm: function() {
      var self = this;
      self.error = '';
      self.loading = true;
      
      this.$refs.loginForm.validate(function(valid) {
        if (valid) {
          var baseApi = process.env.VUE_APP_BASE_API || 'http://localhost:8080/api';
          var url = baseApi + '/auth/login';
          
          request.post(url, self.loginForm)
            .then(function(response) {
              // 保存token
              if (response.data && response.data.data) {
                localStorage.setItem('token', response.data.data);
                self.$router.push(self.$route.query.redirect || '/');
              } else {
                self.error = '登录响应格式错误';
                self.loading = false;
              }
            })
            .catch(function(err) {
              self.error = err.response?.data?.message || '登录失败，请重试';
              self.loading = false;
            });
        } else {
          self.loading = false;
        }
      });
    }
  }
};
</script>

<style scoped>
.login-container {
  max-width: 350px;
  margin: 100px auto;
  padding: 20px;
  border: 1px solid #e6e6e6;
  border-radius: 5px;
}
.login-container h2 {
  text-align: center;
  margin-bottom: 20px;
}
.error-message {
  color: #f56c6c;
  margin-top: 10px;
  text-align: center;
}
</style>